<template>
  <div class="container">
    <div class="container-left1">
      <LeftLevelNavigation ref="leftLevelNavigation"></LeftLevelNavigation>
    </div>
    <div class="container-main">
      <router-view></router-view>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {};
  },
  mounted() {
    
  },
  methods: {
    
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  .container-left1 {
    flex-shrink: 0;
  }
  .container-main {
    width: 100%;
  }
}
</style>
  